import { useMutation } from '@tanstack/vue-query'
import { computed } from 'vue'

import { companiesService } from 'src/services/api/companies.service'
import { log } from 'src/services/app/log.service'
import { notifyService } from 'src/services/app/notify.service'
import { NOTIFICATION_MESSAGES } from 'src/services/consts/notification.const'

export function useSuggestCompanyMutation() {
  const suggestCompanyMutation = useMutation({
    mutationFn: (companyName) => companiesService.getCompanySuggestions({ companyName }),
    onError: (error) => {
      notifyService.error(NOTIFICATION_MESSAGES.error.getSuggestions)
      log.error('Error getting company suggestions:', error)
    },
  })

  const aiSuggestion = computed(() => suggestCompanyMutation.data.value?.aiSuggestion ?? null)
  const companiesInDb = computed(() => suggestCompanyMutation.data.value?.companiesInDb ?? [])
  const suggestionError = computed(() => {
    const data = suggestCompanyMutation.data.value
    if (data?.error) return data.error
    if (suggestCompanyMutation.error.value) return 'Failed to get suggestions'
    return null
  })

  return {
    suggestCompany: suggestCompanyMutation.mutateAsync,
    isSuggesting: suggestCompanyMutation.isPending,
    aiSuggestion,
    companiesInDb,
    suggestionError,
    resetSuggestCompany: suggestCompanyMutation.reset,
  }
}
